import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';

import { HttpBase } from 'app/services/http-base.service';

@Injectable()
export class CommonService extends HttpBase {
    constructor(http: HttpClient, router: Router, translateService: TranslateService) {
        super(http, router, translateService);
    }

    getClientName = (): Observable<{ success: boolean, clientName: string }> => {
        return this.get<{ success: boolean, clientName: string }>('/api/home/getclientname');
    }

    saveFile = (url): Observable<any> =>{
        return this.get<any>(url, {responseType: 'blob'});
    };
}



// WEBPACK FOOTER //
// ./src/app/services/common.service.ts